import Card from "./Card";

function SettingCard({

    title,

    children,
    onClick

}){

    return(

        <Card onClick={onClick}>

            <h3
                style={{
                    marginTop:0,
                    marginBottom:"18px"
                }}
            >

                {title}

            </h3>

            {children}

        </Card>

    );

}

export default SettingCard;
